<portal-slideshow
  [entries]="entries"
  [selected]="selected"
  [hasWrapper]="true"
></portal-slideshow>
